import i18n from "i18next";
import {
    initReactI18next
} from "react-i18next";

import languageEN from "./localization/en.json";
import languageNL from "./localization/nl.json";

export const SHOPCRATE_LANGUAGE = process.env.REACT_APP_SHOPCRATE_LANGUAGE ? process.env.REACT_APP_SHOPCRATE_LANGUAGE : "nl";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: languageEN,
            nl: languageNL
        },
        /* default language when load the website in browser */
        lng: SHOPCRATE_LANGUAGE,
        /* When react i18next not finding any language to as default in browser */
        fallbackLng: SHOPCRATE_LANGUAGE,
        /* debugger For Development environment */
        debug: true,
        ns: ["translations"],
        defaultNS: "translations",
        keySeparator: ".",
        interpolation: {
            escapeValue: false,
            formatSeparator: ","
        },
        react: {
            wait: true,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default'
        }
    });

export default i18n;
